import { render, staticRenderFns } from "./GamificationPointsModal.vue?vue&type=template&id=10783fb6&"
import script from "./GamificationPointsModal.vue?vue&type=script&lang=js&"
export * from "./GamificationPointsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports